import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 500px)
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSupport = () => {
    const element = document.getElementById('support');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-164">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-ivory/95 backdrop-blur-md border-t border-gold/20 p-4 pb-safe" data-id="element-165">
          <button onClick={scrollToSupport} className="w-full bg-saffron text-navy font-medium py-4 rounded-sm tracking-widest uppercase text-sm shadow-lg active:scale-[0.98] transition-transform" data-id="element-166">
            {t('stickyMobileCta.text')}
          </button>
        </motion.div>}
    </AnimatePresence>;
}